import {Pipe,PipeTransform} from '@angular/core';

@Pipe({name:'currencyFormat'})
export class CurrencyFormatPipe implements PipeTransform{
	transform(value:number|null|undefined):string{
		return (value??0).toLocaleString('en-US',{style:'currency',currency:'USD',minimumFractionDigits:0,maximumFractionDigits:0});
	}
}
